import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";

export async function cancelPlaceSelection(bookingId: string): Promise<IApiResponse<string>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.cancelPlaceSelection(bookingId);

  return await apiRequest<string>(endpoint, 'POST');
}
